// material-ui
import { Typography, Box } from '@mui/material';
import { appTitle } from 'store/baseConfig';
import titleLogoImg from 'assets/images/logo/titleLogoImg.png';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const Logo = ({ style }) => {
    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            <img
                src={titleLogoImg}
                alt="OneDeal Pay 로고"
                style={{
                    width: '100%',
                    height: 'auto',
                    maxHeight: '60px',
                    objectFit: 'contain',
                    ...style
                }}
            />
        </Box>
    );
};

export default Logo;
